/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the Earnings interface.
 */
export function instanceOfEarnings(value) {
    return true;
}
export function EarningsFromJSON(json) {
    return EarningsFromJSONTyped(json, false);
}
export function EarningsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'total': json['Total'] == null ? undefined : json['Total'],
        'today': json['Today'] == null ? undefined : json['Today'],
    };
}
export function EarningsToJSON(json) {
    return EarningsToJSONTyped(json, false);
}
export function EarningsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Total': value['total'],
        'Today': value['today'],
    };
}
